var map = {
	"./blue/char/duck.png": 402,
	"./blue/char/sheep.png": 403,
	"./green/blobfish.png": 566,
	"./green/char/giraffe.png": 404,
	"./green/char/pig.png": 405,
	"./green/char/unicorn.png": 406,
	"./orange/bear.png": 567,
	"./orange/crocodile.png": 568,
	"./orange/duck.png": 569,
	"./orange/elephant.png": 570,
	"./orange/giraffe.png": 571,
	"./orange/hedgehog.png": 572,
	"./orange/koala.png": 573,
	"./orange/owl.png": 574,
	"./orange/pelican.png": 575,
	"./orange/poodle.png": 576,
	"./orange/rabbits.png": 577,
	"./orange/sheep.png": 578,
	"./pink/char/koala.png": 407,
	"./pink/char/rabbit.png": 393,
	"./red/char/hedgehog.png": 408,
	"./red/zebra.png": 579,
	"./yellow/bear.png": 580,
	"./yellow/char/deer.png": 409,
	"./yellow/char/unicorn.png": 453,
	"./yellow/crocodile.png": 581,
	"./yellow/duck.png": 582,
	"./yellow/elephant.png": 583,
	"./yellow/giraffe.png": 584,
	"./yellow/hedgehog.png": 585,
	"./yellow/koala.png": 586,
	"./yellow/owl.png": 587,
	"./yellow/pelican.png": 588,
	"./yellow/poodle.png": 589,
	"./yellow/rabbits.png": 590,
	"./yellow/sheep.png": 591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;